import { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

export default function SettingsStripe(props) {

	const initialState = {
		live_key: "",
		test_key: ""
	}

	const [settingsData, setSettingsData] = useState(initialState);

	const handleSettingsData = (key, value) => {
		setSettingsData({ ...settingsData, [key]: value });
	}

	useEffect(() => {
		if (props.settingsData) setSettingsData(props.settingsData);
		else setSettingsData(initialState);
	}, [props.settingsData])

	return (
		<Container fluid className="px-0">

			<Row className="pb-4 m-0">
				<Col lg={5} className="px-0">
					<Form.Group>
						<Form.Label className="SFProDisplay-Semibold">
							{props.config.wording.text_1}
						</Form.Label>
						<Form.Control
							type="text"
							value={settingsData.live_key}
							onChange={(e) => handleSettingsData("live_key", e.target.value)}
							placeholder={props.config.wording.text_2}
						/>
					</Form.Group>
					<Form.Group className="pt-4">
						<Form.Label className="SFProDisplay-Semibold">
							{props.config.wording.text_3}
						</Form.Label>
						<Form.Control
							type="text"
							value={settingsData.test_key}
							onChange={(e) => handleSettingsData("test_key", e.target.value)}
							placeholder={props.config.wording.text_4}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="d-flex align-items-center justify-content-between border-top border-secondary pt-4 m-0">
				<Col xs="auto" className="px-0">
					<Button className="px-4 rounded-5" onClick={() => props.updateSettings("edit_stripe_settings", settingsData)}>
						{props.settingsData ? props.config.wording.text_5 : props.config.wording.text_6}
					</Button>
				</Col>
				{props.settingsData &&
					<Col xs="auto" className="px-4">
						<Button variant="link" className="text-decoration-none text-dark-red p-0" onClick={() => props.handleModal("delete_stripe_settings")}>
							{props.config.wording.text_7}
						</Button>
					</Col>
				}
			</Row>

		</Container>
	);
}